import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
} from '@mui/material';
import { StockDto } from '../../services/stocksApi';

interface StockSelectionDialogProps {
  open: boolean;
  stocks: StockDto[];
  selectedStock: string;
  onStockChange: (stockSymbol: string) => void;
  onClose: () => void;
  onConfirm: () => void;
  getAvailableShares: (stockSymbol: string) => number;
}

export default function StockSelectionDialog({
  open,
  stocks,
  selectedStock,
  onStockChange,
  onClose,
  onConfirm,
  getAvailableShares,
}: StockSelectionDialogProps) {
  const availableStocks = stocks.filter(stock => getAvailableShares(stock.symbol) > 0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Selecionar ação a vender</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          {availableStocks.length === 0 ? (
            <Typography color="text.secondary">
              Não há ações disponíveis para venda. É preciso comprar ações primeiro.
            </Typography>
          ) : (
            <FormControl fullWidth>
              <InputLabel>Símbolo</InputLabel>
              <Select
                value={selectedStock}
                onChange={(e) => onStockChange(e.target.value)}
                label="Símbolo"
              >
                {availableStocks.map(stock => (
                  <MenuItem key={stock.publicId} value={stock.symbol}>
                    {stock.symbol} ({getAvailableShares(stock.symbol)} unidades disponíveis)
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          disabled={!selectedStock || availableStocks.length === 0}
        >
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
